module.exports = __webpack_public_path__ + "img/hero.0737fbef.jpg";